import { useParams } from 'react-router-dom';

import { HighlightCanvas } from '../highlight-canvas';
import { BoundingBoxSelector, SelectionBox } from './bounding-box-selector';
import { DocViewerLoader } from './doc-viewer-loader';
import { useGetDocImagePresignedURLV2 } from '@/api/queries/useGetDocImagePresignedURLV2';
import { BoundingBox, BoundingBoxWithId } from '@/types';
interface ImagePageProps {
  pageNumber: number;
  top: number;
  dimensions: {
    height: number;
    width: number;
  };
  highlights: BoundingBoxWithId[];
  highlightedFactId?: string | null;
  onHighlightClick?: (id: string) => void;
  highlightedChunkId?: string | null;
  docId: string;
  isSelectionMode?: boolean;
  onSelectionComplete?: (
    boundingBox: BoundingBox,
    imageData: string,
    selectionBox: SelectionBox,
    pageNumber: number,
  ) => void;
  maintainSelection?: boolean;
  activeSelection?: { box: SelectionBox; pageNumber: number } | null;
}

export const ImagePage = ({
  pageNumber,
  top,
  dimensions,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
  docId,
  isSelectionMode,
  onSelectionComplete,
  maintainSelection,
  activeSelection,
}: ImagePageProps) => {
  const { matterId } = useParams();
  const { data: imageUrl } = useGetDocImagePresignedURLV2(matterId, docId, pageNumber - 1);

  return (
    <div
      key={pageNumber}
      className="absolute left-1/2 -translate-x-1/2 overflow-hidden bg-white shadow-lg/6"
      style={{
        top: top,
        height: dimensions.height,
        width: dimensions.width,
      }}
      data-page-number={pageNumber}
    >
      {imageUrl ? (
        <>
          <img src={imageUrl} alt={`PDF Page ${pageNumber}`} className="select-none" crossOrigin="anonymous" />

          <HighlightCanvas
            highlights={highlights}
            pageNumber={pageNumber}
            width={dimensions.width}
            height={dimensions.height}
            highlightedFactId={highlightedFactId}
            onHighlightClick={onHighlightClick}
            highlightedChunkId={highlightedChunkId}
          />

          {(isSelectionMode || (maintainSelection && activeSelection?.pageNumber === pageNumber)) &&
            onSelectionComplete && (
              <BoundingBoxSelector
                isActive={
                  (isSelectionMode || (maintainSelection && activeSelection?.pageNumber === pageNumber)) ?? false
                }
                pageNumber={pageNumber}
                pageWidth={dimensions.width}
                pageHeight={dimensions.height}
                onSelectionComplete={(boundingBox, imageData, selectionBox) =>
                  onSelectionComplete(boundingBox, imageData, selectionBox, pageNumber)
                }
                maintainSelection={maintainSelection}
                activeSelection={activeSelection?.pageNumber === pageNumber ? activeSelection.box : null}
              />
            )}
        </>
      ) : (
        <DocViewerLoader />
      )}
    </div>
  );
};
